// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ZoomSelect_wrapper__a8VVF"};